import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import Heading from '../Heading/Heading'

export const StyledCard = styled.div`
  flex-direction: column;
  display: flex;
  border-radius: ${pxToRem(5)};
  border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.unique.white};
  width: inherit;
  padding: ${pxToRem(20)};
  background-color: ${({ theme }) => theme.colors.unique.white};
  text-decoration: inherit;
`

export const StyleHeading = styled(Heading)`
  margin-bottom: ${pxToRem(20)};
  font-weight: ${({ theme }) => theme.fonts.weight.medium};
  font-size: ${({ theme }) => theme.fonts.sizes.titleH3};
  line-height: ${({ theme }) => theme.fonts.lineHeight.titleH3};
`

// TODO: Font-size unchanged because of paragraph 1rem
export const StyledRichText = styled.div`
  opacity: 0.7;
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  line-height: ${({ theme }) => theme.fonts.lineHeight.base};
`